import React from "react";

export const GoogleIcon = () => (
  <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: "12px" }}>
    <g fill="none" fillRule="evenodd">
      <path d="M17.64 9.2045c0-.6381-.0573-1.2518-.1636-1.8409H9v3.4818h4.8436c-.2086 1.125-.8441 2.0782-1.7777 2.7218v2.2582h2.9086c1.7018-1.5668 2.6836-3.8736 2.6836-6.621z" fill="#4285F4"></path>
      <path d="M9 18c2.43 0 4.4673-.806 5.9564-2.1818l-2.9086-2.2582c-.806.5409-1.8368.8618-3.0477.8618-2.3441 0-4.3282-1.5818-5.0359-3.7109H.9573v2.3318C2.4382 16.1455 5.4818 18 9 18z" fill="#34A853"></path>
      <path d="M3.9641 10.71c-.1818-.5409-.1818-1.125 0-1.6664V6.7118H.9573C.3477 7.9618 0 9.4382 0 11c0 1.5618.3477 3.0382.9573 4.2882L3.9641 12.355v-1.645z" fill="#FBBC05"></path>
      <path d="M9 3.5782c1.3214 0 2.5077.4545 3.4405 1.3455l2.5818-2.5818C13.4632.8918 11.43 0 9 0 5.4818 0 2.4382 1.8545.9573 4.6382L3.9641 6.97C4.6718 4.8409 6.6559 3.5782 9 3.5782z" fill="#EA4335"></path>
    </g>
  </svg>
);

export const GitHubIcon = () => (
  <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" style={{ marginRight: "12px" }}>
    <path fillRule="evenodd" d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z" fill="#333"></path>
  </svg>
);

export const MicrosoftIcon = () => (
  <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 23" style={{ marginRight: "12px" }}>
    <path fill="#f35325" d="M1 1h10v10H1z"/>
    <path fill="#81bc06" d="M12 1h10v10H12z"/>
    <path fill="#05a6f0" d="M1 12h10v10H1z"/>
    <path fill="#ffba08" d="M12 12h10v10H12z"/>
  </svg>
);

export const EmailIcon = () => (
  <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: "12px" }}>
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
    <polyline points="22,6 12,13 2,6"></polyline>
  </svg>
);
